import API_ROUTES from "../constants/api";
import HttpUtil from "../http-handler/http-util";

export default class StakehodlerLibraryService {

    static upsertStakeholder(payload) {
        return HttpUtil.post(
            API_ROUTES.STAKEHOLDER_LIBRARY.UPSERT_STAKEHOLDER,
            payload
        );
    }

    static getParentStakeholders() {
        return HttpUtil.get(
            API_ROUTES.STAKEHOLDER_LIBRARY.GET_PARENT_STAKEHOLDERS
        );
    }

    static getChildStakeholders(id) {
        return HttpUtil.get(
            API_ROUTES.STAKEHOLDER_LIBRARY.GET_CHILD_STAKEHOLDERS
                .replace("<id>", id)
        );
    }

    static deleteStakeholder(id) {
        return HttpUtil.delete(
            API_ROUTES.STAKEHOLDER_LIBRARY.DELETE_STAKEHOLDER
                .replace('<id>', id)
        );
    }

    static getAllStakeholders(year, companyId) {
        return HttpUtil.get(
            API_ROUTES.STAKEHOLDER_MAPPING.GET_STAKEHOLDERS
                .replace('<year>', year)
                .replace('<companyId>', companyId)
        );
    }

    static getStakeholderDet(id) {
        return HttpUtil.get(
            API_ROUTES.STAKEHOLDER_MAPPING.GET_STAKEHOLDER_DETAILS
                .replace('<id>', id)
        );
    }

    static upsertStakeholderCategory(year, companyId, payload) {
        return HttpUtil.post(
            API_ROUTES.STAKEHOLDER_MAPPING.UPSERT_STAKEHOLDER
                .replace('<year>', year)
                .replace('<companyId>', companyId), payload
        );
    }

    static upsertStakeholderGroup(year, companyId, payload) {
        return HttpUtil.post(
            API_ROUTES.STAKEHOLDER_MAPPING.UPSERT_STAKEHOLDER
                .replace('<year>', year)
                .replace('<companyId>', companyId), payload
        );
    }

    static upsertStakeholderEmails(id, companyId, payload) {
        return HttpUtil.post(
            API_ROUTES.STAKEHOLDER_MAPPING.UPSERT_STAKEHOLDER_EMAILS
                .replace('<id>', id)
                .replace('<companyId>', companyId), payload
        );
    }

    static mapStakeholders(year, companyId, payload) {
        return HttpUtil.patch(
            API_ROUTES.STAKEHOLDER_MAPPING.MAP_STAKEHOLDER
            .replace('<year>', year)
            .replace('<companyId>', companyId), payload
        );
    }

    static getChildrenStakeholders(year, companyId) {
        return HttpUtil.get(
            API_ROUTES.STAKEHOLDER_MAPPING.GET_STAKEHOLDER_CHILDREN
                .replace('<year>', year)
                .replace('<companyId>', companyId)
        );
    }

    static deleteStakeData(id) {
        return HttpUtil.delete(
            API_ROUTES.STAKEHOLDER_MAPPING.DELETE_STAKEHOLDER
                .replace('<id>', id)
        );
    }

    static updateStakeholderGroup(id, payload) {
        return HttpUtil.put(
            API_ROUTES.STAKEHOLDER_MAPPING.UPDATE_STAKEHOLDER
                .replace('<id>', id), payload
        );
    }

    static getAllParentChildStakeholders() {
        return HttpUtil.get(
            API_ROUTES.STAKEHOLDER_MAPPING.GET_ALL_PARENT_CHILD_STAKEHOLDERS
        );
    }

    static deleteStakeholderGroupEmail(id) {
        return HttpUtil.delete(
            API_ROUTES.STAKEHOLDER_MAPPING.DELETE_STAKEHOLDER_GROUP
                .replace('<id>', id)
        );
    }

    static getAllStakeholdersDefaultView(year, companyId, pageSize, pageNumber,key) {
        return HttpUtil.get(
            API_ROUTES.STAKEHOLDER_MAPPING.GET_STAKEHOLDER_DEFAULTVIEW
                .replace('<year>', year)
                .replace('<companyId>', companyId)
                .replace("<pageSize>", pageSize)
                .replace("<pageNumber>", pageNumber)
                .replace("<key>", key)
        );
    }

    static upsertMultipleStakeholders(companyId, payload) {
        return HttpUtil.post(
            API_ROUTES.STAKEHOLDER_MAPPING.UPSERT_MULTIPLE_STAKEHOLDERS
                .replace('<companyId>', companyId), payload
        );
    }
}